// extracted by mini-css-extract-plugin
export var container = "imagelayer-module--container--HrpUx";
export var img = "imagelayer-module--img--s7xVg";
export var moveWrapper = "imagelayer-module--moveWrapper--MMSg+";
export var moveimg = "imagelayer-module--moveimg--wyDVd";
export var wrapper = "imagelayer-module--wrapper--Zjvc8";